import { createApp } from "vue";
import VueClickAway from "vue3-click-away";
import axios from "axios";
import router from "@/router";
import store from "@/store";
import App from "./App.vue";
import { config } from "./constants";

export const StemWijzerHTTP = axios.create({
  baseURL: config.settings.analytics ? config.settings.analytics.baseUrl : "",
});

// Enable RSInject module
import rsinject from "./modules/rsinject/module";
if (config.settings.readspeaker?.show) {
  store.registerModule("rsinject", rsinject.store);
  store.dispatch("rsinject/init", router, { root: true });
}

const app = createApp(App);
app.use(VueClickAway);
app.use(router);
app.use(store);
app.mount("#app");
